import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';

class Store extends EventDrivenStore {
  constructor() {
    const defaultState = {
      list_all: {
        list: [],
        error: null,
        loading: true
      },
      add: {
        loading: false,
        error: null
      },
      remove: {
        loading: false,
        error: null
      }
    };

    super('blacklist', defaultState);
    this.defaultState = defaultState;
  }

  async setupEvents() {
    // List
    this.on(constants.EVENTS.BLACKLIST.LIST_ALL.REFRESHING, () => {
      this.state.list_all.loading = true;
      this.state.list_all.error = null;
    });

    this.on(constants.EVENTS.BLACKLIST.LIST_ALL.REFRESHED, (data) => {
      this.state.list_all.list = Array.isArray(data) ? data : [];
      this.state.list_all.loading = false;
      this.state.list_all.error = null;
    });

    this.on(constants.EVENTS.BLACKLIST.LIST_ALL.REFRESH_ERROR, (error) => {
      this.state.list_all.loading = false;
      this.state.list_all.error = error?.message || error || 'Erreur de chargement';
      this.state.list_all.list = [];
    });

    // Add
    this.on(constants.EVENTS.BLACKLIST.ADD.SUBMIT, () => {
      this.state.add.loading = true;
      this.state.add.error = null;
    });

    this.on(constants.EVENTS.BLACKLIST.ADD.SUCCESS, () => {
      this.state.add.loading = false;
      this.state.add.error = null;
    });

    this.on(constants.EVENTS.BLACKLIST.ADD.ERROR, (error) => {
      this.state.add.loading = false;
      this.state.add.error = error?.message || error;
    });

    // Remove
    this.on(constants.EVENTS.BLACKLIST.REMOVE.SUBMIT, () => {
      this.state.remove.loading = true;
      this.state.remove.error = null;
    });

    this.on(constants.EVENTS.BLACKLIST.REMOVE.SUCCESS, () => {
      this.state.remove.loading = false;
      this.state.remove.error = null;
    });

    this.on(constants.EVENTS.BLACKLIST.REMOVE.ERROR, (error) => {
      this.state.remove.loading = false;
      this.state.remove.error = error?.message || error;
    });
  }
}

export default Store;
